import { render, staticRenderFns } from "./PositionFairPayCardView.vue?vue&type=template&id=3c69550e&scoped=true"
import script from "./PositionFairPayCardView.vue?vue&type=script&setup=true&lang=js"
export * from "./PositionFairPayCardView.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PositionFairPayCardView.vue?vue&type=style&index=0&id=3c69550e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c69550e",
  null
  
)

export default component.exports